var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPermitted)?_c('router-link',{staticClass:"sidebar-menu-item",attrs:{"to":_vm.route.path}},[_c('div',{class:_vm.route.meta.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.route.meta.name))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa4dfa6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarLink.vue
// module id = 1172
// module chunks = 0